<template>
  <a-card :bordered="false">
    <a-tabs v-model="activeKey">
      <a-tab-pane key="appVersion" tab="GIS采集APP">
        <app-version v-if="activeKey === 'appVersion'" />
      </a-tab-pane>
      <a-tab-pane key="waterMeterApp" tab="抄表APP">
        <water-meter-app v-if="activeKey === 'waterMeterApp'" />
      </a-tab-pane>
      <a-tab-pane key="smartWaterApp" tab="智慧水务APP">
        <smart-water-app v-if="activeKey === 'smartWaterApp'" />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import AppVersion from '@/views/manager/app/appVersion'
import WaterMeterApp from '@/views/meter-reading/waterMeterApp'
import SmartWaterApp from '@/views/manager/app/smartWaterApp'

export default {
  name: 'AppMobileTabs',
  components: {
    AppVersion,
    WaterMeterApp,
    SmartWaterApp
  },
  data () {
    return {
      activeKey: 'appVersion'
    }
  }
}
</script>
